import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface CronJobItem {
  name: string;
  schedule: string;
  suspend: boolean;
  active: number;
  last_schedule_time: string | null;
  last_successful_time: string | null;
  last_run_name: string | null;
  last_run_status: string | null;
  last_run_duration_seconds: number | null;
}

export async function listCronJobs(navigate: NavigateFunction): Promise<{ items: CronJobItem[] }> {
  const res = await apiFetch(`${API_URL}/admin/cronjobs`, { method: "GET" }, navigate);
  if (!res?.ok) {
    let detail = `Erreur ${res?.status ?? "?"}`;
    try {
      const body = await res?.json();
      if (body?.detail) detail = `${detail} : ${body.detail}`;
    } catch {
      /* ignore */
    }
    throw new Error(detail);
  }
  return res.json();
}
